export default "__VITE_ASSET__a3d8d031__"